export const UserAuth = {
    email: '',
    password: '',
  };
  
  export const AuthResponse = {
    message: '',
    user: {},
  };